import {useFormContext} from 'react-hook-form';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@common-web/components/ui/form';
import {Input} from '@common-web/components/ui/input';

export function Section125Agent({showPepm = false}: {showPepm?: boolean}) {
  const {control} = useFormContext();
  return (
    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
      <FormField
        control={control}
        name={'section125Form.agentOfRecord.firstName'}
        render={({field}) => (
          <FormItem>
            <FormLabel>First Name</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name={'section125Form.agentOfRecord.lastName'}
        render={({field}) => (
          <FormItem>
            <FormLabel>Last Name</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name={'section125Form.agentOfRecord.phone'}
        render={({field}) => (
          <FormItem>
            <FormLabel>Phone</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name={'section125Form.agentOfRecord.email'}
        render={({field}) => (
          <FormItem>
            <FormLabel>Email</FormLabel>
            <FormControl>
              <Input type='email' {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name={'section125Form.agentOfRecord.additionalPhone'}
        render={({field}) => (
          <FormItem>
            <FormLabel>Additional Phone (Optional)</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name={'section125Form.agentOfRecord.additionalEmail'}
        render={({field}) => (
          <FormItem>
            <FormLabel>Additional Email (Optional)</FormLabel>
            <FormControl>
              <Input type='email' {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      {showPepm && (
        <FormField
          control={control}
          name={'section125Form.agentOfRecord.pepm'}
          render={({field}) => (
            <FormItem>
              <FormLabel>PEPM</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </div>
  );
}
